import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { IoClose, IoMenu } from 'react-icons/io5';
import { openWhatsAppConsultation } from '../../utils/whatsapp';
import logo from '../../images/logo.png';
import './Header.css';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const location = useLocation();

  // Handle scroll for sticky header
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsServicesDropdownOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const isServicesActive = () => {
    return location.pathname.startsWith('/services');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
  };

  return (
    <header className={`header ${isSticky ? 'sticky' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo">
            <img src={logo} alt="نمو ماركتينج" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <Link to="/" className={isActive('/') && !isActive('/services') ? 'active' : ''}>
              الرئيسية
            </Link>
            <Link to="/about" className={isActive('/about') ? 'active' : ''}>
              من نحن
            </Link>

            {/* Services Dropdown */}
            <div className="dropdown">
              <button
                className={`dropdown-toggle ${isServicesActive() ? 'active' : ''}`}
                onMouseEnter={() => setIsServicesDropdownOpen(true)}
                onMouseLeave={() => setIsServicesDropdownOpen(false)}
              >
                الخدمات <span className="arrow">▼</span>
              </button>
              <div
                className={`dropdown-menu ${isServicesDropdownOpen ? 'show' : ''}`}
                onMouseEnter={() => setIsServicesDropdownOpen(true)}
                onMouseLeave={() => setIsServicesDropdownOpen(false)}
              >
                <Link to="/services" className={isActive('/services') ? 'active' : ''}>
                  جميع الخدمات
                </Link>
                <Link to="/services/web-design" className={isActive('/services/web-design') ? 'active' : ''}>
                  تصميم المواقع
                </Link>
                <Link to="/services/social-media" className={isActive('/services/social-media') ? 'active' : ''}>
                  إدارة السوشيال ميديا
                </Link>
                <Link to="/services/paid-ads" className={isActive('/services/paid-ads') ? 'active' : ''}>
                  الإعلانات الممولة
                </Link>
              </div>
            </div>

            <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>
              اتصل بنا
            </Link>
          </nav>

          {/* WhatsApp CTA Button */}
          <button
            className="btn btn-whatsapp-header"
            onClick={openWhatsAppConsultation}
            aria-label="تواصل عبر واتساب"
          >
            <FaWhatsapp />
            تواصل معنا
          </button>

          {/* Mobile Menu Toggle */}
          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="قائمة التنقل"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? <IoClose /> : <IoMenu />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="nav-mobile">
            <Link to="/" className={isActive('/') ? 'active' : ''}>
              الرئيسية
            </Link>
            <Link to="/about" className={isActive('/about') ? 'active' : ''}>
              من نحن
            </Link>

            {/* Mobile Services Submenu */}
            <div className="mobile-submenu">
              <button
                className={`submenu-toggle ${isServicesActive() ? 'active' : ''}`}
                onClick={toggleServicesDropdown}
              >
                الخدمات <span className={`arrow ${isServicesDropdownOpen ? 'up' : 'down'}`}>▼</span>
              </button>
              {isServicesDropdownOpen && (
                <div className="submenu-items">
                  <Link to="/services" className={isActive('/services') ? 'active' : ''}>
                    جميع الخدمات
                  </Link>
                  <Link to="/services/web-design" className={isActive('/services/web-design') ? 'active' : ''}>
                    تصميم المواقع
                  </Link>
                  <Link to="/services/social-media" className={isActive('/services/social-media') ? 'active' : ''}>
                    إدارة السوشيال ميديا
                  </Link>
                  <Link to="/services/paid-ads" className={isActive('/services/paid-ads') ? 'active' : ''}>
                    الإعلانات الممولة
                  </Link>
                </div>
              )}
            </div>

            <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>
              اتصل بنا
            </Link>

            {/* WhatsApp Button in Mobile Menu */}
            <button
              className="btn btn-whatsapp-mobile"
              onClick={openWhatsAppConsultation}
            >
              <FaWhatsapp />
              تواصل معنا عبر واتساب
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
